import { render, staticRenderFns } from "./MoleculeEditionBillingArtificialIntelligence.vue?vue&type=template&id=40d636c6"
import script from "./MoleculeEditionBillingArtificialIntelligence.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingArtificialIntelligence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports